<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <h4>Mağaza Muhasebe Raporu</h4>
        <p style="color: #6c757d">
          {{
            isAdmin
              ? "Tüm mağazaların ticari ve muhasebe bilgilerini görüntüleyin"
              : "Mağazanızın ticari ve muhasebe bilgilerini görüntüleyin"
          }}
        </p>
      </v-col>
    </v-row>
    <v-row v-if="isAdmin">
      <v-col cols="12" md="4" sm="4">
        <v-text-field
          v-model="CompanyName"
          append-icon="mdi-magnify"
          label="Firma Adı"
          single-line
          hide-details
          maxlength="200"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <v-text-field
          v-model="BranchName"
          append-icon="mdi-magnify"
          label="Şube Adı"
          single-line
          hide-details
          maxlength="200"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <v-text-field
          v-model="TaxIdentityNumber"
          append-icon="mdi-magnify"
          label="Vergi No"
          single-line
          hide-details
          maxlength="200"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <v-menu
          v-model="menuStart"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="StartDate"
              style="font-weight: bold"
              prepend-icon="event"
              label="Başlangıç Tarihi"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="StartDate"
            :max="new Date().toISOString().substring(0, 10)"
            @input="onStartDateChange"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <v-menu
          v-model="menuEnd"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="EndDate"
              style="font-weight: bold"
              prepend-icon="event"
              label="Bitiş Tarihi"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="EndDate"
            :picker-date.sync="endPickerDate"
            :max="new Date().toISOString().substring(0, 10)"
            @input="onEndDateChange"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        md="12"
        sm="12"
        style="
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
        "
      >
        <v-btn
          color="#4d48f9"
          style="text-transform: none !important; color: white"
          @click="searchFilter()"
        >
          <v-icon style="font-size: 17px" color="white"> search </v-icon>
          Ara
        </v-btn>
        <v-btn
          depressed
          @click="clearSearch()"
          style="
            text-transform: none !important;
            float: left;
            color: white;
            background: white;
            color: #6c757d;
            border: 1px solid #dee2e6;
            cursor: pointer;
          "
        >
          <v-icon style="font-size: 17px" color="#6c757d">delete</v-icon>
          Filtreleri Temizle
        </v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        <p style="color: #6c757d; font-size: 14px; font-weight: 400">
          Toplam
          <strong style="color: black">{{ pagination.totalItems }}</strong>
          Kayıt Bulundu
        </p>
        <v-spacer></v-spacer>
        <div style="display: flex; align-items: center; gap: 10px">
          <v-btn
            depressed
            :disabled="loading"
            :loading="loading"
            @click="exportReports('excel')"
            style="
              text-transform: none !important;
              float: left;
              color: white;
              background: white;
              color: #6c757d;
              border: 1px solid #dee2e6;
              cursor: pointer;
            "
          >
            <v-icon style="font-size: 17px" color="#6c757d"
              >mdi-file-excel</v-icon
            >
            Excel İndir
          </v-btn>
          <v-btn
            depressed
            :disabled="loading"
            :loading="loading"
            @click="exportReports('csv')"
            style="
              text-transform: none !important;
              float: left;
              color: white;
              background: white;
              color: #6c757d;
              border: 1px solid #dee2e6;
              cursor: pointer;
            "
          >
            <v-icon style="font-size: 17px" color="#6c757d"
              >mdi-file-delimited</v-icon
            >
            CSV İndir
          </v-btn>
        </div>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="storeAccountingHeaders"
        :items="allStoreAccountingList"
        style="white-space: nowrap"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.orderDegree="{ item }">
          <!-- <v-icon small class="mr-2" @click="routeCompanyEdit(item)">mdi-pencil</v-icon> -->
          <span v-if="item.orderDegree != null">{{ item.orderDegree }}</span>
          <span
            v-if="item.orderDegree == null"
            style="color: black; font-size: 20px"
          >
            -
          </span>
        </template>
        <template v-slot:item.address="{ item }">
          <v-tooltip bottom v-if="item.address">
            <template v-slot:activator="{ on, attrs }">
              <span class="address-area" v-bind="attrs" v-on="on">
                {{ item.address }}
              </span>
            </template>
            <span>{{ item.address }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.executionActive="{ item }">
          <span
            class="badge"
            :class="item.executionActive ? 'badge-active' : 'badge-passive'"
            >{{ item.executionActive ? "Aktif" : "Pasif" }}</span
          >
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="storeAccountingPageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
          :total-visible="10"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "StoreAccountingReports",
  data: () => ({
    storeAccountingPageData: {
      pageNumber: 1,
      pageSize: 10,
      CompanyName: "",
      BranchName: "",
      TaxIdentityNumber: "",
      StartDate: null,
      EndDate: null,
    },
    CompanyName: "",
    BranchName: "",
    TaxIdentityNumber: "",
    StartDate: null,
    EndDate: null,
    menuStart: false,
    menuEnd: false,
    endPickerDate: null,
    isAdmin: false,
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    storeAccountingHeaders: [
      {
        text: "Firma adı",
        value: "companyName",
        align: "start",
        sortable: false,
      },
      //{ text: "Telefon", value: "phone",sortable: false  },
      // { text: "İsim/Soyisim", value: "fullName",sortable: false  },
      { text: "Şube Adı", value: "branchName", sortable: false },
      { text: "İletişim Kişisi", value: "contactPerson", sortable: false },
      { text: "Telefon Numarası", value: "phoneNumber", sortable: false },
      { text: "Firma Ünvanı", value: "companyTitle", sortable: false },
      { text: "Vergi Dairesi", value: "taxAdministration", sortable: false },
      { text: "Vergi No", value: "taxIdentityNumber", sortable: false },
      { text: "Adres", value: "address", sortable: false },
      {
        text: "Fatura Mail Adresi",
        value: "invoiceMailAddress",
        sortable: false,
      },
      { text: "IBAN", value: "iban", sortable: false },
      { text: "Banka Adı", value: "bankName", sortable: false },
      { text: "Yetkili Kişi", value: "executionName", sortable: false },
      { text: "Yetkili Kişi Ünvanı", value: "executionTitle", sortable: false },
      {
        text: "Mağaza Statüsü",
        value: "executionActive",
        sortable: false,
      },
    ],
  }),
  watch: {
    "$route.query.page"(val) {
      const pageNumber = val ? Number(val) : 1;
      this.getPageNumber(pageNumber);
    },
  },
  computed: mapGetters(["allStoreAccountingList", "loading"]),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1;
    this.storeAccountingPageData.pageNumber = Number(page);

    this.userRoles = JSON.parse(localStorage.getItem("userRoles"));
    if (
      this.userRoles.find((x) => x == "PanelUser") != null &&
      this.userRoles.find((x) => x == "PanelUser") != undefined
    ) {
      this.isAdmin = true;
    }

    this.getStoreAccountingList(this.storeAccountingPageData).then(
      (response) => {
        this.pagination.totalItems = response.totalCount;
        this.pagination.pagesLength = response.totalPages;
      },
    );
  },
  methods: {
    ...mapActions(["getStoreAccountingList", "getStoreAccountingReports"]),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.storeAccountingPageData.pageSize = val;
      this.storeAccountingPageData.pageNumber = 1;
      this.getStoreAccountingList(this.storeAccountingPageData).then((res) => {
        this.pagination.pagesLength = res.totalPages;
      });
    },
    searchFilter() {
      this.storeAccountingPageData.CompanyName = this.CompanyName;
      this.storeAccountingPageData.BranchName = this.BranchName;
      this.storeAccountingPageData.TaxIdentityNumber = this.TaxIdentityNumber;
      this.storeAccountingPageData.pageNumber = 1;
      this.storeAccountingPageData.StartDate = this.StartDate
        ? this.formatDate(this.StartDate)
        : "";
      this.storeAccountingPageData.EndDate = this.EndDate
        ? this.formatDate(this.EndDate)
        : "";
      this.getStoreAccountingList(this.storeAccountingPageData).then(
        (response) => {
          this.pagination.totalItems = response.totalCount;
          this.pagination.pagesLength = response.totalPages;
        },
      );
    },
    clearSearch() {
      this.storeAccountingPageData = {
        pageNumber: 1,
        pageSize: 10,
        CompanyName: "",
        BranchName: "",
        TaxIdentityNumber: "",
      };
      this.CompanyName = "";
      this.BranchName = "";
      this.TaxIdentityNumber = "";
      this.StartDate = null;
      this.EndDate = null;
      this.searchFilter();
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.storeAccountingPageData.pageNumber = val;
      if (val !== 1) {
        this.$router.push({ query: { page: val } });
      }
      this.getStoreAccountingList(this.storeAccountingPageData);
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return;
      this.$router.push({ path: this.$route.fullPath, query: { page: val } });
    },
    async exportReports(type) {
      const result = await this.getStoreAccountingReports({
        pageNumber: this.storeAccountingPageData.pageNumber,
        pageSize: this.storeAccountingPageData.pageSize,
        CompanyName: this.storeAccountingPageData.CompanyName,
        BranchName: this.storeAccountingPageData.BranchName,
        TaxIdentityNumber: this.storeAccountingPageData.TaxIdentityNumber,
        StartDate: this.storeAccountingPageData.StartDate
          ? this.storeAccountingPageData.StartDate
          : "",
        EndDate: this.storeAccountingPageData.EndDate
          ? this.storeAccountingPageData.EndDate
          : "",
        type: type,
      });
      if (result.status != 200)
        this.$toasted.show(
          result.data.friendlyMessage.message || "Hata Oluştu.",
          {
            duration: 3000,
            position: "top-right",
            type: "error",
          },
        );
      else {
        this.$toasted.show("Rapor İndirme Başarılı", {
          duration: 3000,
          position: "top-right",
          type: "success",
        });
      }
    },
    formatDate(date) {
      const [y, m, d] = date.split("-");
      return `${d}-${m}-${y}`;
    },
    onStartDateChange(value) {
      this.StartDate = value;
      this.menuStart = false;

      if (this.EndDate) {
        const start = new Date(value);
        const end = new Date(this.EndDate);
        if (start > end) {
          this.EndDate = value;
        }
      }
    },
    onEndDateChange(value) {
      this.EndDate = value;
      this.menuEnd = false;

      if (this.StartDate) {
        const start = new Date(this.StartDate);
        const end = new Date(value);
        if (end < start) {
          this.StartDate = value;
        }
      }
    },
  },
};
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}

.v-data-footer__icons-after {
  display: none;
}
.address-area {
  max-width: 200px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.badge-active {
  background-color: #e6f7f0;
  color: #2e7d32;
}
.badge-passive {
  background-color: #fdecea;
  color: #c62828;
}
</style>
